<script setup>
import { ref } from 'vue';
import { multiLan, currentLanguage } from './assets/lan';
import { openPwaHomePage } from "./utils/pwa"
import googlePlayLogo from './assets/images/google_play.png';
import topDeveloperBadge from './assets/images/google_play_topbar_right.png';
import { pwaInstalled,deferredPrompt,showInstallBackTip } from './app.js'
import icShare from './assets/images/ic_share.png';
import icAddWishlist from './assets/images/ic_addwishlist.png';
import icDun from './assets/images/ic_dun.png';
import GiftDialog from './components/GiftDialog.vue'
import QRCode from './components/QRCode.vue'
import { onClickInstall, installProgress, showGiftDialog } from "./app.js";
import { isMobileDevice,isAndroid,isChrome } from './utils/pwa';
import { onMounted } from 'vue';
import OpenInDefaultTip from './components/OpenInDefaultTip.vue'
import { getUUID } from './utils/uuid';
import { debugStep,showOpenInDefaultTip } from './global';
const appInfo = {
  name: '1v1 video chat',
  rating: '4.8',
  reviews: multiLan('reviews'),
  downloads: '57M+',
  ageRating: '18+',
  description: multiLan('meet_people'),
  privacy: multiLan('protect_privacy')
};

const downloadTimer = ref(0);
const isAnimating = ref(true);
const currentLang = ref(currentLanguage());

function onProgressComplete(event) {
  isAnimating.value = false;
}

const topBannerShowBoxShadow = ref(false);
function onScroll(event) {
  console.log('scroll', event.screenTop)
  const scrollTop = event.target.screenTop;
  topBannerShowBoxShadow.value = scrollTop > 0

}
onMounted(() => {
  window.addEventListener('scroll', onScroll);
})
</script>

<template>

  <!-- <div class="debugInfo"> {{  getUUID() }}</div> -->
  <div class="app-container">
    <!-- Header -->
    <div class="header" :class="{ 'box-shadow': topBannerShowBoxShadow }">
      <img :src="googlePlayLogo" alt="Google Play" class="google-play-logo" />
      <div class="top-developer">
        <img :src="topDeveloperBadge" alt="Top Developer" class="developer-badge" />
      </div>
    </div>

    <!-- App Info -->
    <div class="app-info">
      <div class="app-header">
        <div class="icon-wrapper" @animationend="onProgressComplete">
          <img src="./assets/images/pwa_logo_192.png" alt="App Icon" class="app-icon" />
          <svg v-if="installProgress > 0 && installProgress < 100" class="progress-ring" viewBox="0 0 120 120">
            <circle :class="['progress-ring-circle', { 'animating': isAnimating }]" cx="60" cy="60" r="65" />
          </svg>
        </div>
        <div style="width: 20px;"></div>
        <div class="app-title">
          <h1>Grace-{{ multiLan('app_name') }} <span class="verified-badge">✓</span></h1>
          <div class="developer-name">
            <div class="progress" v-if="installProgress > 0">{{ installProgress.toFixed(1) }}%&nbsp;</div>
            {{ multiLan('app_name_desc') }}
          </div>
          <div class="verify-text">
            <img :src="icDun" alt="Verify" class="verify-icon" />
            <div style="width: 4px;"></div>
            <span>{{ multiLan('verified_text') }}</span>
          </div>
        </div>
      </div>

      <!-- Stats -->
      <div class="stats">
        <div class="stat-item">
          <div class="stat-value">{{ appInfo.rating }}★</div>
          <div class="stat-label">{{ appInfo.reviews }}</div>
        </div>
        <div class="stat-divider"></div>
        <div class="stat-item">
          <div class="stat-value">{{ appInfo.downloads }}</div>
          <div class="stat-label">{{ multiLan('downloads') }}</div>
        </div>
        <div class="stat-divider"></div>
        <div class="stat-item">
          <div class="stat-value">{{ appInfo.ageRating }}</div>
          <div class="stat-label">{{ multiLan('rated_for') }}</div>
        </div>
      </div>
      <div v-if="!isMobileDevice()" class="pc-install-indicator">
        <div class="child1">
          <img class="img" src="./assets/images/code_img.png" />
          <img class="code-light" src="./assets/images/code_light.png" />
        </div>

        <div class="child2">
          <QRCode class="code"></QRCode>
        </div>
        <img class="arror-right" src="./assets/images/ic_arrowhead.png" />
        <div class="child3">
          <img class="app-icon" src="./assets/images/pwa_logo_192.png" />
          <div class="install-button">{{ multiLan('install_button') }}</div>
        </div>

      </div>


      <!-- Install Button -->
      <div class="install-button-container">
        <div v-if="pwaInstalled && installProgress >= 100" class="success-message">{{ multiLan('install_success') }}</div>
        <div class="install-button" @click="onClickInstall"
          :class="{ 'disabled': installProgress > 0 && installProgress < 100 }">
          <span class="lightning">⚡</span>
          {{ pwaInstalled && (installProgress >= 100 || installProgress == 0) ? multiLan('play_now') : installProgress > 0 ?
            multiLan('installing') : multiLan('rapid_install') }}
        </div>
        
        <div class="come-back-tip" v-if="showInstallBackTip">
          {{ multiLan('come_back_tip') }}
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button class="action-btn" @click="onClickInstall">
          <img :src="icShare" alt="Share" class="action-icon" />
          {{ multiLan('share') }}
        </button>
        <button class="action-btn" @click="onClickInstall">
          <img :src="icAddWishlist" alt="Add to wishlist" class="action-icon" />
          {{ multiLan('add_to_wishlist') }}
        </button>
      </div>

      <!-- App Screenshots -->
      <div class="screenshots">
        <div class="screenshot-card" v-for="i in 4" :key="i">
       
          <img :src="`./screen_shots/${currentLanguage()}/${i}.jpg`" :alt="multiLan('screenshot')" />
        </div>
    
      </div>

      <!-- About Section -->
      <div class="about-section">
        <div class="section-header">
          <h2>{{ multiLan('about_this_app') }}</h2>
          <span class="arrow">→</span>
        </div>
        <div class="tags">
          <span class="tag">{{ multiLan('chat') }}</span>
          <span class="tag">{{ multiLan('video') }}</span>
        </div>
      </div>

      <!-- Reviews Section -->
      <div class="reviews-section">
        <div class="reviews-header">
          <h2>{{ multiLan('ratings_and_reviews') }}</h2>
          <!-- <span class="see-all">{{ multiLan('see_all') }}</span> -->
          <div class="intro" id="reviews_dec">{{ multiLan('reviews_verified') }}</div>
        </div>
        <div class="reviews-subtitle">{{ multiLan('reviews_subtitle') }}</div>
        <div class="rating-overview">
          <div class="rating-big">
            <div class="rating-number">{{ appInfo.rating }}</div>
            <div class="rating-stars">★★★★★</div>
            <div class="rating-count">{{ appInfo.reviews }} {{ multiLan('reviews') }}</div>
          </div>
          <div class="rating-bars">
            <div class="rating-bar-item">
              <div class="rating-label">5★</div>
              <div class="rating-bar">
                <div class="rating-bar-fill" style="width: 80%;"></div>
              </div>
            </div>
            <div class="rating-bar-item">
              <div class="rating-label">4★</div>
              <div class="rating-bar">
                <div class="rating-bar-fill" style="width: 60%;"></div>
              </div>
            </div>
            <div class="rating-bar-item">
              <div class="rating-label">3★</div>
              <div class="rating-bar">
                <div class="rating-bar-fill" style="width: 40%;"></div>
              </div>
            </div>
            <div class="rating-bar-item">
              <div class="rating-label">2★</div>
              <div class="rating-bar">
                <div class="rating-bar-fill" style="width: 20%;"></div>
              </div>
            </div>
            <div class="rating-bar-item">
              <div class="rating-label">1★</div>
              <div class="rating-bar">
                <div class="rating-bar-fill" style="width: 10%;"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="reviews-list">
          <div class="review-item">
            <div class="review-header">
              <img class="review-avatar" src="./assets/images/avatar1.jpg" alt="Avatar" />
              <div class="review-info">
                <div class="review-author">{{ multiLan('review_author_1') }}</div>
                <div class="review-meta">
                  <div class="review-stars">★★★★★</div>
                  <div class="review-date">{{ multiLan('review_date_1') }}</div>
                </div>
              </div>
              <button class="review-menu">...</button>
            </div>
            <div class="review-content">{{ multiLan('review_content_1') }}</div>
            <div class="review-actions">
              <div class="review-helpful">{{ multiLan('helpful') }}</div>
              <div class="review-buttons">
                <button class="review-btn">{{ multiLan('yes') }}</button>
                <button class="review-btn">{{ multiLan('no') }}</button>
              </div>
            </div>
          </div>
          <div class="review-item">
            <div class="review-header">
              <img class="review-avatar" src="./assets/images/avatar2.jpg" alt="Avatar" />
              <div class="review-info">
                <div class="review-author">{{ multiLan('review_author_2') }}</div>
                <div class="review-meta">
                  <div class="review-stars">★★★★★</div>
                  <div class="review-date">{{ multiLan('review_date_2') }}</div>
                </div>
              </div>
              <button class="review-menu">...</button>
            </div>
            <div class="review-content">{{ multiLan('review_content_2') }}</div>
            <div class="review-actions">
              <div class="review-helpful">{{ multiLan('helpful') }}</div>
              <div class="review-buttons">
                <button class="review-btn">{{ multiLan('yes') }}</button>
                <button class="review-btn">{{ multiLan('no') }}</button>
              </div>
            </div>
          </div>
          <div class="review-item">
            <div class="review-header">
              <img class="review-avatar" src="./assets/images/avatar3.jpg" alt="Avatar" />
              <div class="review-info">
                <div class="review-author">{{ multiLan('review_author_3') }}</div>
                <div class="review-meta">
                  <div class="review-stars">★★★★★</div>
                  <div class="review-date">{{ multiLan('review_date_3') }}</div>
                </div>
              </div>
              <button class="review-menu">...</button>
            </div>
            <div class="review-content">{{ multiLan('review_content_3') }}</div>
            <div class="review-actions">
              <div class="review-helpful">{{ multiLan('helpful') }}</div>
              <div class="review-buttons">
                <button class="review-btn">{{ multiLan('yes') }}</button>
                <button class="review-btn">{{ multiLan('no') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-safety">
        <h2>{{ multiLan('data_safety') }} <span>›</span></h2>
        <p>{{ multiLan('data_safety_desc') }}</p>
        <div class="safety-list">
          <div class="safety-item">
            <span>🔒</span>
           
            <div>
              <div>{{ multiLan('no_data_shared') }}
                {{ multiLan('learn_more_sharing') }}</div>

            </div>
          </div>
          <div class="safety-item">
            <span>☁️</span>
           
            <div>
              <div>{{ multiLan('data_collection') }}
                {{ multiLan('app_info_performance') }}</div>

            </div>
          </div>
          <div class="safety-item">
            <span>🔐</span>
           
            <div>{{ multiLan('data_encrypted') }}</div>
          </div>
          <div class="safety-item">
            <span>🗑️</span>
            
            <div>{{ multiLan('data_deletion') }}</div>
          </div>
          <div class="otherlink">{{ multiLan('see_details') }}</div>
        </div>

      </div>
    </div>
    <GiftDialog v-model="showGiftDialog" @install="onClickInstall" />

  </div>
  <OpenInDefaultTip class="open-in-default-tip" v-if="showOpenInDefaultTip" @close="showOpenInDefaultTip = false" />

</template>
<style>
.debugInfo{
  top: 0;
  left: 0;
  position: fixed;
  z-index: 100001; 
  color:red;
}
.open-in-default-tip {

  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100000;
}

body {
  background-color: white;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  -webkit-user-select: none;
  /* 适用于Safari和Chrome等WebKit浏览器 */
  -moz-user-select: none;
  /* 适用于Firefox浏览器 */
  -ms-user-select: none;
  /* 适用于IE和Edge浏览器 */
  user-select: none;
  /* 标准语法 */
}
</style>
<style lang="scss" scoped>
.app-container {
  max-width: 800px;

  margin: 0 auto;
  padding: 5rem 1rem 2rem 1rem;
  font-family: 'Roboto', sans-serif;
}

.header {
  width: 100%;
  box-sizing: border-box;
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  background-color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.box-shadow {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.google-play-logo {
  height: 40px;
  object-fit: contain;
}

.developer-badge {
  height: 40px;
  object-fit: contain;
}

.otherlink {
  display: block;
  color: #028760;
  font-weight: 600;
  font-size: 17px;
  margin: 20px 0;
  text-decoration: none;
}

.pc-install-indicator {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;

  .child1,
  .child2,
  .child3 {

    height: 30vw;
    object-fit: contain;
    border: none;
  }

  .child1 {
    width: 40%;
    display: flex;
    align-items: center;
    justify-self: center;
    position: relative;

    .img {
      width: 100%;
      object-fit: contain;
      position: absolute;
    }

    .code-light {
      width: 30%;
      left: 32%;
      position: absolute;
      animation: float 2s ease-in-out infinite;
    }

  }

  .child2 {

    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    min-width: 240px;
  }

  .arror-right {
    width: 10%;
    height: 10%;
    object-fit: contain;
  }

  .child3 {
    width: 30%;
    max-height: 300px;
    border: 3px solid #000;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .app-icon {
      max-width: 50%;
    }

    .install-button {
      width: 70%;
      text-align: center;
      height: 20px;
      font-weight: bold;
      border-radius: 10px;
      background: #056949;
      color: white;
      padding: 1rem;
      border-radius: 8px;
      text-align: center;
      margin: 1rem 0;
      cursor: pointer;
      font-weight: bold;

    }

  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-40px);
  }
}

.app-info {
  padding: 1rem;
}

.app-header {
  display: flex;
  gap: 10px;
  margin-bottom: 2rem;
}

.icon-wrapper {
  position: relative;
  width: 80px;
  min-width: 80px;
  height: 80px;
  display: flex;


  .app-icon {
    width: 80px;
    height: 80px;
    border-radius: 16px;
    position: relative;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .progress-ring {

    position: absolute;
    top: -10px;
    left: -10px;
    width: calc(100% + 20px);
    height: calc(100% + 20px);
    transform: rotate(-90deg);
    overflow: visible;

    .progress-ring-circle {
      fill: none;
      stroke: #056949;
      stroke-width: 3;
      stroke-linecap: round;
      stroke-dasharray: 409;
      /* 2 * π * 65 */
      stroke-dashoffset: 409;

      &.animating {
        animation: progress-ring 2s linear infinite;
      }
    }
  }
}

@keyframes progress-ring {
  0% {
    stroke-dashoffset: 409;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

.app-title h1 {
  margin: 0;
  font-size: 1.2rem;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  white-space: nowrap;

}

.developer-name {
  color: #056949;
  margin: 0.5rem 0;
  text-align: start;
  display: flex;
  align-items: center;
  flex-direction: row;

  .progress {
    text-align: end;
    width: 60px;
  }
}

.verify-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-size: 0.9rem;
  white-space: nowrap;
}

.verify-icon {
  width: 16px;
  height: 16px;

}

.action-icon {
  width: 20px;
  height: 20px;
  
}

.verified-badge {
  color: #1a73e8;
  background: #e8f0fe;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8em;
}

.stats {
  display: flex;
  justify-content: space-around;
  margin: 2rem 0;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 1.2rem;
  font-weight: bold;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
}

.stat-divider {
  width: 1px;
  background: #e0e0e0;
}

.install-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .install-button {
    width: 100%;
    background: #056949;
    color: white;
    padding: 1rem;
    border-radius: 8px;
    text-align: center;
    margin: 1rem 0;
    cursor: pointer;
    font-weight: bold;
  }

  .disabled {
    background-color: #ccc;
  }
  .come-back-tip{
    color: #f00;
    font-size: 12px;
    text-align: center;
  }
}



.download-timer {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-top: 0.5rem;
}

.lightning {
  color: #ffd700;
  margin-right: 8px;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
  justify-content: center;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  color: #056949;
  cursor: pointer;
  font-weight: 500;
}

.screenshots {
  display: flex;

  margin: 2rem 0;
  overflow-x: scroll;
}

.screenshot-card {
  width: 150px;
  height: 300px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 0 0.5rem;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0 1rem;
}

.section-header h2 {
  margin: 0;
  font-size: 1.3rem;
}

.arrow {
  color: #666;
}

.tags {
  display: flex;
  gap: 1rem;
}

.tag {
  background: #f5f5f5;
  padding: 0.5rem 1rem;
  border-radius: 16px;
  font-size: 0.9rem;
}

.review-note {
  color: #666;
  font-size: 14px;
  margin-top: 8px;
  line-height: 1.4;
}

.qr-code {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.reviews-section {

  background: white;
  border-radius: 8px;
  margin-top: 2rem;
}

.reviews-header {
  display: flex;
  flex-direction: column;
  text-align: start;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;

  h2 {
    font-size: 1.2rem;
    margin: 0;
  }

  .see-all {
    color: #1a73e8;
    font-size: 1.5rem;
  }
}

.reviews-subtitle {
  color: #5f6368;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.rating-overview {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
}

.rating-big {
  text-align: center;
  min-width: 100px;

  .rating-number {
    font-size: 3rem;
    font-weight: bold;
  }

  .rating-stars {
    color: #ffd700;
    font-size: 1.2rem;
    margin: 0.5rem 0;
  }

  .rating-count {
    color: #5f6368;
    font-size: 0.9rem;
  }
}

.rating-bars {
  flex-grow: 1;
  max-width: 300px;
}

.rating-bar-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  .rating-label {
    min-width: 20px;
  }

  .rating-bar {
    flex-grow: 1;
    height: 8px;
    background: #f1f3f4;
    border-radius: 4px;
    overflow: hidden;

    .rating-bar-fill {
      height: 100%;
      background: #1e8e3e;
      border-radius: 4px;
    }
  }
}

.reviews-list {
  .review-item {
    padding: 1rem 0;
    border-top: 1px solid #e8eaed;

    &:first-child {
      border-top: none;
    }
  }
}

.review-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.review-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e8eaed;
}

.review-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;

}

.review-author {
  font-weight: 500;
}

.review-meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #5f6368;
  font-size: 0.9rem;

  .review-stars {
    color: #ffd700;
  }
}

.review-menu {
  background: none;
  border: none;
  color: #5f6368;
  font-size: 1.2rem;
  padding: 0.5rem;
  cursor: pointer;
}

.review-content {
  margin: 0.5rem 0;
  line-height: 1.5;
  color: #202124;
  text-align: start;
}

.review-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  font-size: 0.9rem;

  .review-helpful {
    color: #5f6368;
  }

  .review-buttons {
    display: flex;
    gap: 0.5rem;
  }

  .review-btn {
    padding: 0.5rem 1rem;
    border: 1px solid #dadce0;
    border-radius: 4px;
    background: white;
    color: #1a73e8;
    cursor: pointer;

    &:hover {
      background: #f8f9fa;
    }
  }
}

.data-safety {
  margin-top: 2rem;

  background: white;
  border-radius: 8px;
  text-align: left;

  h2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 1rem;
    font-size: 1.2rem;

    span {
      color: #1a73e8;
    }
  }

  p {
    color: #5f6368;
    font-size: 0.9rem;
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }

  .safety-list {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    border: 1px solid #e8eaed;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    align-items: flex-start;
  }

  .safety-item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 1rem;

    span {
      font-size: 1.2rem;
    }

    >div {
      flex: 1;

      div {
        font-size: 0.9rem;
        margin-bottom: 0.25rem;
      }

      small {
        color: #5f6368;
        font-size: 0.8rem;
      }
    }
  }

  button {
    margin-top: 1.5rem;
    padding: 0.5rem 1rem;
    border: 1px solid #dadce0;
    border-radius: 4px;
    background: white;
    color: #1a73e8;
    cursor: pointer;

    &:hover {
      background: #f8f9fa;
    }
  }
}

.success-message {
  color: #4CAF50;
  font-size: 14px;
  animation: flash 0.5s ease-in-out 3;
}

@keyframes flash {
  0% {
    opacity: 1;
    text-shadow: 0 0 10px #4CAF50;
  }

  50% {
    opacity: 0.5;
    text-shadow: 0 0 20px #4CAF50;
  }

  100% {
    opacity: 1;
    text-shadow: 0 0 10px #4CAF50;
  }
}
</style>
